import { render, staticRenderFns } from "./TableRisk.vue?vue&type=template&id=c7f0092c&scoped=true&"
import script from "./TableRisk.vue?vue&type=script&lang=js&"
export * from "./TableRisk.vue?vue&type=script&lang=js&"
import style0 from "./TableRisk.vue?vue&type=style&index=0&id=c7f0092c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f0092c",
  null
  
)

export default component.exports